import { notification } from 'antd';
import { useState } from 'react';
import { AppModal } from 'shared/UI/UIKit/Modal';
import { AppFlex } from 'shared/UI/UIKit/Flex';
import { AppText } from 'shared/UI/UIKit/Text';
import { removeBuilding } from 'services/api';
import type { RemoveBuildingModalProps } from '../types';
import { BuildingFooter } from '../Footer/BuildingFooter';
import styles from './Remove.module.scss';

export const RemoveBuildingModal = ({
  selectedBuilding,
  visible,
  hide,
  onItemRemove,
}: RemoveBuildingModalProps) => {
  const [loading, setLoading] = useState(false);

  const confirm = () => {
    setLoading(true);
    removeBuilding(selectedBuilding!.id)
      .then(() => {
        onItemRemove();
        hide();
      })
      .catch((error) => {
        notification.error({ message: 'Не удалось удалить здание' });
        throw error;
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const footer = <BuildingFooter onSubmit={confirm} hideModal={hide} title="Удалить" />;
  const content = (
    <AppFlex unit="8" className={styles.content}>
      <AppText size={16} type="secondary">
        Подтвердите удаление здания
      </AppText>
      <AppText size={18}>{selectedBuilding?.name}</AppText>
    </AppFlex>
  );

  return (
    <AppModal
      visible={visible}
      onCancel={hide}
      size="auto"
      content={content}
      destroyOnClose
      footer={footer}
      loading={loading}
      title="Удаление здания"
      maskClosable={false}
    />
  );
};
